import { css } from "@emotion/css";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { ActivityCommentType } from "@/models/BGMLogbook.ts";
import { getActivityIntensityTranslation } from "@/models/diabetes/ActivityModel.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { toDateTime } from "@/utils/dateUtils.ts";

import { DetailComment } from "./DetailComment";

export const ActivityComment = ({ activityComment }: { activityComment: ActivityCommentType }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const time = toDateTime(activityComment.date).toLocaleString(DateTime.TIME_SIMPLE);

  const text = `${time}, ${activityComment.duration}min, 
  ${t(getActivityIntensityTranslation(activityComment.intensity))}`;

  return (
    <DetailComment
      className={styles.chip}
      icon={<Icons.activity className={styles.icon} />}
      commentText={text}
      tooltipText={t("bgmLogBook.activityTooltip")}
    />
  );
};

const makeStyles = (theme: Theme) => ({
  chip: css`
    background-color: ${theme.palette.bgm.orangeBackground};
  `,
  icon: css`
    height: ${theme.spacing(4)};
    color: ${theme.palette.bgm.activityIcon};
  `,
});
